import React from 'react'
import './Footer.scss'

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
        	<footer className="clearfix">
				<section className="site-centered">
					<div className="row">
						<div className='main--footer--holder'>
							<div className='footer--links'>
								<div className='first--col'>
									<h4 className='col-title'>OVERVIEW</h4>
									<a href="https://www.noonhome.com/" target="_blank" className='footer-link-title'>Home</a>
									<a href="https://www.noonhome.com/how-it-works" target="_blank" className='footer-link-title'>How it works</a>
									<a href="https://www.noonhome.com/products" target="_blank" className='footer-link-title'>Products</a>
								</div>
								<div className='second--col'>
									<h4 className='col-title'>COMPANY</h4>
									<a href="https://www.noonhome.com/blog" target="_blank" className='footer-link-title'>Blog</a>
									<a href="/resources" className='footer-link-title'>Press & Assets</a>
								</div>
								<div className='third--col'>
									<h4 className='col-title'>SUPPORT</h4>
									<a href="https://www.noonhome.com/support" target="_blank" className='footer-link-title'>Help center</a>
									<a href="https://www.noonhome.com/contact" target="_blank" className='footer-link-title'>Contact us</a>
									<a href="https://www.noonhome.com/legal/privacy-policy" target="_blank" className='footer-link-title'>Policy</a>
								</div>

							</div>
							<div className='footer--links--placeholder'>
							</div>
						</div>
					</div>
					<div className="row">
						<div className='social--handles--holder'>
							<div className='social--icons'>
								<a href="https://www.facebook.com/noonhome/" target="_blank"><img src={require('./Images/icon-facebook.png')} alt="Facebook" /></a>
								<a href="https://www.twitter.com/NoonHome" target="_blank"><img src={require('./Images/icon-twitter.png')} alt="Twitter" /></a>
								<a href="https://www.instagram.com/noonhome" target="_blank"><img src={require('./Images/icon-instagram.png')} alt="Instagram" /></a>
								<a href="https://www.linkedin.com/company/10700690/" target="_blank"><img src={ require('./Images/icon-linked-in.png')} alt="Linked In" /></a>
							</div>
							<div className='social--buttons'>
								<a href="https://apps.apple.com/us/app/noonhome/id1287243899" target="_blank"><img src={ require('./Images/icon-app-store.svg')} alt="App Store" /></a>
								<a href="https://play.google.com/store/apps/details?id=com.noonhome.alaska" target="_blank"><img src={ require('./Images/icon-google-store.svg')} alt="Google Store" /></a>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="footer-copyR">
							<p>&copy; {new Date().getFullYear()} Racepoint Energy LLC</p>
						</div>
					</div>

		</section>
	</footer>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Footer/index.js